import { Component } from '@angular/core';

import { LayoutService } from '../../services/layout.service';
import { PlantMapService } from 'app/plantmap/services/plant-map.service';
import { StorageService } from 'app/shared/services/storage.service';
import { HistoryService } from 'app/history/services/history.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'flow-header',
    templateUrl: 'flow-header.component.html',
})

export class FlowHeaderComponent {

    constructor(
        private _layoutService: LayoutService,
        private _storageService: StorageService
    ) { }

    ngOnInit() {
    }
    getPPMFlowHeaderStatus() {
        return this._layoutService.vLayoutState.appPPMFlowHeader;
    }

    getNCEFlowHeaderStatus() {
        return this._layoutService.vLayoutState.appNCEApplicationFlowHeader;
    }

    getNCEFlowState(name: string, inProgress: boolean) {
        let thisState = this._layoutService.getNCEStateFromName(name);
        let currentState = this._layoutService.getNCECurrentState();
        if ((inProgress && thisState == currentState) || (!inProgress && thisState < currentState)) {
            return true;
        } else {
            return false;
        }
    }

    getPlantmapFlowState(name: string, inProgress: boolean) {
        let thisState = this._layoutService.getPlantmapStateFromName(name);
        let currentState = this._layoutService.getPlantmapCurrentState();
        if ((inProgress && thisState == currentState) || (!inProgress && thisState < currentState)) {
            return true;
        } else {
            return false;
        }
    }

    isRestrictedArea() {
        return this._layoutService.isRestrictedArea();
    }

    isExtensionNCE() {
        return this._layoutService.isExtensionNCE();
    }

    get isNewRequest(): boolean {
        if (this._storageService.getSessionItem('plantMapData') != null) {
            return true;
        } else {
            return false;
        }
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/components/header/flow-header.component.ts